import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

declare const $: any;

interface DatePickerProps {
    onDatesChange: (dates: { start: moment.Moment; end: moment.Moment }) => void;
    filterDay?: number;
}

const DatePicker: React.FC<DatePickerProps> = ({ onDatesChange, filterDay }) => {
    const { t } = useTranslation();
    const rangeElement = useRef(null);
    const daysToSubtract = filterDay ? filterDay : 29;
    const [rangeFilter, setRangeFilter] = useState({
        start: moment().subtract(daysToSubtract, 'days'),
        end: moment(),
    })

    useEffect(() => {
        if (!rangeElement || !rangeElement.current) return;

        $(rangeElement.current).find('.js-daterangepicker-predefined-preview').html(rangeFilter.start.format('MMMM D, YYYY') + ' - ' + rangeFilter.end.format('MMMM D, YYYY'));

        const cb = (start, end) => {
            setRangeFilter({ start, end });

            $(rangeElement.current).find('.js-daterangepicker-predefined-preview').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));

            if (onDatesChange) {
                onDatesChange({ start, end });
            }
        };

        $(rangeElement.current).daterangepicker({
            startDate: filterDay ? moment().subtract(filterDay, 'days') : rangeFilter.start,
            endDate: filterDay ? moment() : rangeFilter.end,
            ranges: {
                [t('date-time.today')]: [moment(), moment()],
                [t('date-time.yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                [t('date-time.last-days-7')]: [moment().subtract(6, 'days'), moment()],
                [t('date-time.last-days-30')]: [moment().subtract(29, 'days'), moment()],
                [t('date-time.current-month')]: [moment().startOf('month'), moment().endOf('month')],
                [t('date-time.last-month')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            locale: {
                applyLabel: t('apply-btn'),
                cancelLabel: t('btn-cancel'),
                customRangeLabel: t('date-time.personalized'),
                daysOfWeek: [
                    t('date-time.sun'),
                    t('date-time.mon'),
                    t('date-time.tue'),
                    t('date-time.wed'),
                    t('date-time.thu'),
                    t('date-time.fri'),
                    t('date-time.sat')
                ],
                monthNames: [
                    t('date-time.jan'),
                    t('date-time.feb'),
                    t('date-time.mar'),
                    t('date-time.apr'),
                    t('date-time.may'),
                    t('date-time.jun'),
                    t('date-time.jul'),
                    t('date-time.aug'),
                    t('date-time.sep'),
                    t('date-time.oct'),
                    t('date-time.nov'),
                    t('date-time.dec')
                ],
            }
        }, cb);
    }, [rangeElement, filterDay]);

    return (
        <button type="button" ref={rangeElement} title="date-picker" className="btn bg-primary text-white">
            <i className="bi-calendar-week me-1"></i>
            <span className="js-daterangepicker-predefined-preview"></span>
        </button>
    );
};

export default DatePicker;
